import { defineStore } from 'pinia'


export const useDialogAlertStore = defineStore({
  id: 'dialogAlert',
  state: () => ({
    data: {
      status:false,
      text: {error: []},
      timeout: 2000
    }
  }),

  actions: {
    dialog_alert_close() {
      Object.assign(this.data, {
        status:false,
       // text: {error: []},
        timeout: 2000
      })
 
    },
    dialog_alert_open(data) {
      Object.assign(this.data, data)
  
    }


  }
})
